import { render, staticRenderFns } from "./AssignmentHoursDisplay.vue?vue&type=template&id=25efc9ec&scoped=true&"
import script from "./AssignmentHoursDisplay.vue?vue&type=script&lang=js&"
export * from "./AssignmentHoursDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentHoursDisplay.vue?vue&type=style&index=0&id=25efc9ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25efc9ec",
  null
  
)

export default component.exports